import { CategoryPageContentAjax } from './category-page-content.backend-model';
import {
  CategoryPageBanner,
  CategoryPageContent,
} from './category-page-content.model';

export function transformCategoryPageContent(
  response: CategoryPageContentAjax,
): CategoryPageContent {
  const articles = response.articles.map(article => ({
    id: article.id,
    title: article.title,
    lead: article.lead,
    coverImageUrl: article.cover_image,
    canonicalUrl: article.canonical_url,
    readTime: article.read_time,
  }));

  const categoryPageHeroBanner: CategoryPageBanner = {
    mobile: response.hero_banner_urls.mobile_banner_url,
    tablet: response.hero_banner_urls.tablet_banner_url,
    desktop: response.hero_banner_urls.desktop_banner_url,
  };

  return {
    id: response.id,
    name: response.name,
    seoUrl: response.seo_url,
    bannerId: response.discover_category_banner_id,
    heroBannerUrls: categoryPageHeroBanner,
    order: response.order,
    portfolioItemIds: response.portfolio_item_ids,
    articles,
    freelancerIds: response.freelancer_ids,
    skillIds: response.skill_ids,
    isPrivate: response.is_private,
    isDeleted: response.deleted,
  };
}
